//essential functions

import { isThisTypeNode } from "typescript";


let colors = [
    [0,230,220],
    [16,165,230],
    [30,255,167]
]

var interval;
const getHeight =()=>{
    var body = document.body,
    html = document.documentElement;

var height = Math.max( body.scrollHeight, body.offsetHeight);
    return height;
}
export const background = () => {
    class Particle {
        constructor(x, y, id) {
            this.x = x;
            this.y = y;
            this.id = id
            this.a = 0
            this.c = colors[random(0,3)]
            this.dea = randomFloat(0.003,0.04)
            this.r = random(5, 20);
            this.sv = randomFloat(2,3)
            this.rr = random(0,50)
            this.fadein = true
            this.render = async () => {
                ellipse(this.x, this.y, this.r);
                if(this.fadein){
                    this.a += 0.02;
                }
                if(this.a >= 0.4 && this.fadein){
                    this.fadein = false
                }
            };
            this.move = async () => {
                
                this.x += this.ev.x;
                this.y += this.ev.y;
            };
            this.init = () => {
                this.dx = width / 2 - this.x;
                this.dy = height / 2 - this.y;
                this.l = Math.sqrt(this.dx * this.dx + this.dy * this.dy);
                this.ev = { x: (1 / this.l) / this.sv * this.dx, y: (1 / this.l) / this.sv * this.dy };

            }
            this.fade = () => {
                if(!this.fadein){
                    this.a -= this.dea;
                }
                fill(this.c[0], this.c[1], this.c[2], this.a)
                ctx.fill()
                stroke(0,0,0,0);
                ctx.stroke()
                
            }
            this.fadedOut = () => {
                return this.a <= this.dea;
            }
        }
    }

    var canvas = document.getElementById("bg-canvas")
    canvas.width = window.innerWidth;
    canvas.height = getHeight()
    var width = canvas.width;
    var height = getHeight()
    var ctx = canvas.getContext("2d")

    const line = (sx, sy, ex, ey) => {
        ctx.beginPath();
        ctx.moveTo(sx, sy)
        ctx.lineTo(ex, ey);
        ctx.stroke()
    }
    const ellipse = (x, y, r) => {
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2)
        ctx.stroke()
    }
    const fill = (r,g,b,a)=>{
        ctx.fillStyle =  `rgba(${r},${g},${b},${a})`
    }
    const clear = () => {
        ctx.clearRect(0, 0, width, height);
        ctx.beginPath()
    }
    const stroke = (r, g, b, a) => {
        ctx.strokeStyle = `rgba(${r},${g},${b},${a})`
    }
    var y = 0;
    const randomFloat = (start, end) => {
        return Math.random() * end + start

    }
    const random = (start = 0, end = 0) => {
        return Math.floor(Math.random() * end) + start;
    }
    const partciles = []
    for (var i = 0; i < 4; i++) {
        //generate particles around a screen
        const nn = i == 1 || i == 3 ? 60 : 20
        for (var j = 0; j < nn; j++) {
            const p = new Particle(0, 0, i)
            var rx, ry;
            switch (i) {
                case 0: //top
                    rx = random(0, width);
                    ry = random(0, 30);
                    p.x = rx
                    p.y = ry;
                    break;
                case 1: //right
                    rx = random(width - 50, 50);
                    ry = random(0, height);
                    p.x = rx
                    p.y = ry;
                    break;
                case 3: //left
                    rx = random(0, 30);
                    ry = random(0, height);
                    p.x = rx
                    p.y = ry;
                    break;
            }
            p.init();
            partciles.push(p)

        }
    }
    const loop = async () => {
       
        canvas = document.getElementById("bg-canvas")
        ctx = canvas.getContext("2d")


        clear()
        for (var i = partciles.length - 1; i >= 0; i--) {
            const p = partciles[i]
            p.render()
            p.move();
            p.fade();
            if (p.fadedOut()) {
                const tp = p;
                partciles.splice(i, 1);
                const pa = new Particle(0, 0, tp.id)
                
                var rx, ry;
                switch (tp.id) {
                    case 0: //top
                        rx = random(0, width);
                        ry = random(0, 30);
                        pa.x = rx
                        pa.y = ry;
                        break;
                    case 1: //right
                        rx = random(width - 50, 50);
                        ry = random(0, height);
                        pa.x = rx
                        pa.y = ry;
                        break;
                    case 3: //left
                        rx = random(0, 30);
                        ry = random(0, height);
                        pa.x = rx
                        pa.y = ry;
                        break;
                }
                pa.init();
                partciles.push(pa)
            }
        }
    }
    console.log(width, height)
    loop()
    interval = setInterval(loop, 20)
    console.log(interval)
    window.addEventListener("resize",()=>{
        canvas.width = window.innerWidth;
        canvas.height = getHeight()
        width = window.innerWidth;
        height = getHeight()
    })
}
export const stopBackground = ()=>{
    console.log(interval)
    clearInterval(interval)
}





